import React from "react";
import { CHAINS, CATEGORIES, STATUSES } from "../constants";

const selectCls =
  "px-3 py-2 text-sm border border-gray-700 rounded-md bg-gray-800 text-gray-100 focus:outline-none focus:ring-1 focus:ring-gray-400";

export const EMPTY_FILTERS = { status: "", network_id: "", category: "", featured: "", sponsored: "", search: "" };

export default function ListingFilters({ value, onChange, onReset }) {
  const set = (key) => (e) => onChange({ ...value, [key]: e.target.value });
  const active = Object.keys(EMPTY_FILTERS).some((k) => value[k]);

  return (
    <div className="bl-glass p-4 mb-4">
      <div className="flex flex-wrap gap-3 items-end">
        <div className="flex-1 min-w-[200px]">
          <label className="block text-xs text-gray-400 mb-1" htmlFor="tl-search">Search</label>
          <input
            id="tl-search"
            type="text"
            value={value.search}
            onChange={set("search")}
            placeholder="Name, symbol, address or CoinGecko id"
            className="w-full px-3 py-2 text-sm border border-gray-700 rounded-md bg-gray-800 text-gray-100 focus:outline-none focus:ring-1 focus:ring-gray-400"
          />
        </div>
        <div>
          <label className="block text-xs text-gray-400 mb-1" htmlFor="tl-f-status">Status</label>
          <select id="tl-f-status" value={value.status} onChange={set("status")} className={selectCls}>
            <option value="">All statuses</option>
            {STATUSES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs text-gray-400 mb-1" htmlFor="tl-f-chain">Chain</label>
          <select id="tl-f-chain" value={value.network_id} onChange={set("network_id")} className={selectCls}>
            <option value="">All chains</option>
            {CHAINS.map((c) => <option key={c.network_id} value={String(c.network_id)}>{c.name}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs text-gray-400 mb-1" htmlFor="tl-f-category">Category</label>
          <select id="tl-f-category" value={value.category} onChange={set("category")} className={selectCls}>
            <option value="">All categories</option>
            {CATEGORIES.map((c) => <option key={c.slug} value={c.slug}>{c.name}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs text-gray-400 mb-1" htmlFor="tl-f-featured">Featured</label>
          <select id="tl-f-featured" value={value.featured} onChange={set("featured")} className={selectCls}>
            <option value="">Any</option>
            <option value="true">Featured</option>
            <option value="false">Not featured</option>
          </select>
        </div>
        <div>
          <label className="block text-xs text-gray-400 mb-1" htmlFor="tl-f-sponsored">Sponsored</label>
          <select id="tl-f-sponsored" value={value.sponsored} onChange={set("sponsored")} className={selectCls}>
            <option value="">Any</option>
            <option value="active">Active</option>
            <option value="pending">Pending approval</option>
            <option value="scheduled">Scheduled</option>
            <option value="ended">Ended</option>
          </select>
        </div>
        {active && (
          <button type="button" onClick={onReset} className="px-3 py-2 text-sm text-gray-300 hover:text-gray-100">
            Reset
          </button>
        )}
      </div>
    </div>
  );
}
